'use strict'
// コンテンツの最大画像数
const maxImage = 100
const maxApps = 1
const appInfo = [
  {
    title: 'どうぶつひらがなカタカナをかこう！',
    description: 'たくさんのどうぶつをみて、ひらがな、かたかなをれんしゅうしよう！',
    link: 'Top',
    audioSrc: require('@/assets/wja/audio/writingjapaneseanimal_title_audio.mp3')
  }
]
export default {
  name: 'commonConst',
  methods: {
    getMaxImage: function () {
      return maxImage
    },
    getMaxApps: function () {
      return maxApps
    },
    getAppsInfo: function (num) {
      this.debug(appInfo[num - 1].title)
      this.debug(appInfo[num - 1].description)
      this.debug(appInfo[num - 1].link)
      return appInfo[num - 1]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/commonConst.js